// LA COLA SIN RED · T-3
//
// QUÉ RESUELVE, Y POR QUÉ NO ES OPCIONAL. Una terminal colgada en un
// pasillo de nave pierde la señal a ratos. Sin cola, cada giro que
// coincide con un corte se pierde en silencio: el operador gira, la
// pantalla dice «no se pudo», y él vuelve a su trabajo creyendo que
// tendrá que hacerlo otra vez — o creyendo que ya está.
//
// TRES REGLAS, Y LAS TRES SALEN DE LA DIRECTRIZ:
//
//   1. **Cada giro lleva su hora.** El servidor lo juzga contra la
//      sesión que estaba viva A ESA HORA (§A6). Sin la hora, cinco
//      giros hechos sin red se rechazan todos cuando la sesión muere
//      sola — que es el único caso en que una cola existe.
//   2. **El identificador lo pone el aparato.** Es lo que hace que
//      reenviar no duplique: si lo pusiera el servidor, cada reintento
//      sería un movimiento nuevo.
//   3. **Se sube EN ORDEN y no se borra hasta que el servidor conteste.**
//      Un giro que se borra al mandarlo y cuya respuesta se pierde es un
//      giro perdido.
//
// DÓNDE VIVE. En `localStorage`, igual que el aparato la guardaría en su
// SQLite: si se recarga la página o se va la luz, la cola sigue ahí. Sin
// esto, «offline» duraría lo que la pestaña.

export const CLAVE_COLA = 'tego.terminal.cola';
// Tope bajo a propósito, el mismo del servidor: es la cola de una
// repisa, no una importación. Cincuenta giros sin subir ya son
// muchísimos, y significa que algo lleva roto mucho rato.
export const TOPE = 50;

function leerCrudo() {
  try {
    const c = JSON.parse(localStorage.getItem(CLAVE_COLA) || '[]');
    return Array.isArray(c) ? c : [];
  } catch {
    return [];
  }
}

function escribir(cola) {
  try {
    localStorage.setItem(CLAVE_COLA, JSON.stringify(cola));
  } catch { /* sin almacenamiento, la cola dura lo que la pestaña */ }
  return cola;
}

export function leer() {
  return leerCrudo();
}

export function encolar(giro, ahora = new Date()) {
  const cola = leerCrudo();
  // NO SE ENCOLA DOS VECES EL MISMO. Un reintento del mismo giro no
  // debe crecer la cola.
  if (cola.some((g) => g.id_operacion === giro.id_operacion)) return cola;
  const conHora = { ...giro, ocurrio_en: giro.ocurrio_en || ahora.toISOString() };
  // AL LLENARSE SE TIRA EL MÁS VIEJO, y se dice en pantalla. La
  // alternativa —dejar de aceptar giros nuevos— convierte la terminal en
  // un ladrillo justo cuando alguien está trabajando en ella.
  const nueva = [...cola, conHora].slice(-TOPE);
  return escribir(nueva);
}

export function quitar(ids) {
  const fuera = new Set(ids);
  return escribir(leerCrudo().filter((g) => !fuera.has(g.id_operacion)));
}

export function vaciar() {
  return escribir([]);
}

/** Sube la cola entera, en orden, y quita solo lo que el servidor
 *  contestó.
 *
 *  LO QUE RECHAZA EL SERVIDOR TAMBIÉN SE QUITA, y es deliberado: un
 *  renglón que el servidor rechaza por su motivo —sin sesión a esa hora,
 *  reloj adelantado, SKU que ya no existe— lo va a rechazar igual dentro
 *  de una hora. Dejarlo en la cola haría que la terminal reintentara para
 *  siempre y arrastrara a los buenos que vengan detrás.
 *
 *  Devuelve qué pasó, para que la pantalla pueda decirlo.
 */
export async function subir(mandar) {
  const cola = leerCrudo();
  if (cola.length === 0) return { subidos: 0, rechazados: [], quedan: 0 };

  let r;
  try {
    r = await mandar(cola);
  } catch (e) {
    // SIN RED NO SE PIERDE NADA: la cola se queda tal cual y se
    // reintenta luego.
    return { subidos: 0, rechazados: [], quedan: cola.length, error: e };
  }

  const contestados = (r?.resultados || []).map((x) => x.id_operacion);
  const rechazados = (r?.resultados || []).filter((x) => !x.aplicado);
  const quedan = quitar(contestados);
  return {
    subidos: r?.aplicados || 0,
    rechazados,
    quedan: quedan.length,
  };
}

/** Lo que se pinta arriba a la derecha. Nunca se esconde. */
export function leyendaDeCola(cuantos) {
  if (cuantos === 0) return '';
  if (cuantos === 1) return '1 giro sin subir';
  return `${cuantos} giros sin subir`;
}
